import { get } from "lodash"
import { createSelector } from "reselect"
import { STYLE_AGGREGATION_OPTIONS, AGGREGATION_FUNCTIONS } from "helpers/factorClassification"
import { createQueryStringSelector } from "selectors/queryString"

const EMPTY_ARRAY = []

export const getFocusedChartLine = state => get(state, "modules.analyzeCompositeFactorSensitivity.focusedChartLine")
export const getFactorCategoryId = createQueryStringSelector("factorCategory", "style")
export const getOnly = createQueryStringSelector("only")
export const getDisabled = createQueryStringSelector("disabled", EMPTY_ARRAY)
export const getAggregationFunction = createQueryStringSelector("styleAggregation", AGGREGATION_FUNCTIONS.NONE)
export const getFactorSensitivityType = (_, props) => props.factorSensitivityType

export const getDisplayAddView = (_, props) => props.displayAddView
export const getCategories = (_, props) => props.categories
const getMustAggregateFactors = (_, props) => props.mustAggregateFactors

export const getStyleAggregation = createSelector(
  [getMustAggregateFactors],
  (mustAggregateFactors) => ({
    displayAggregationToggle: mustAggregateFactors,
    aggregationOptions: STYLE_AGGREGATION_OPTIONS,
  }),
)

export const getDisplayAggregationToggle = createSelector(
  [getFactorCategoryId, getMustAggregateFactors],
  (factorCategory, mustAggregateFactors) => mustAggregateFactors && factorCategory === "style",
)
